import { render } from "./SubprojectProjects.vue?vue&type=template&id=4ffef4f9"
import script from "./SubprojectProjects.vue?vue&type=script&lang=js"
export * from "./SubprojectProjects.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/halisclock/releases/44/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__